import { useEffect, useState } from 'react';
import { createRandomPillarSet } from 'src/utils';
import { PillarBlendSet, MessageSkill } from 'src/types';

// (irina) TODO: need refactoring
export const useRecommendedSkills = ({
  skillsUpdateTrigger,
  skill,
}: {
  skillsUpdateTrigger?: number;
  skill?: MessageSkill;
}) => {
  const [randomPillarSet, setRandomPillarSet] = useState<PillarBlendSet>(
    createRandomPillarSet,
  );

  useEffect(() => {
    if (skillsUpdateTrigger) {
      setRandomPillarSet(createRandomPillarSet);
    }
  }, [skillsUpdateTrigger]);

  if (skill) {
    return [randomPillarSet[skill]];
  } else {
    return Object.values(randomPillarSet);
  }
};
